import React from 'react';
import styles from './styles.module.css';
import * as Types from 'helpers/types';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import alertTriangleIcon from 'assets/alert-triangle.svg';
import closeIcon from 'assets/erase-text-symbol.svg';
import { useRejectManualOrder } from 'hooks/useManualOrders';
import { RejectOrderOverlayContent } from 'services/content.js';

const RejectOrderOverlay = ({ manualOrder, closeOverlay }) => {
  const dispatch = useDispatch();
  let history = useHistory();
  const rejectManualOrder = useRejectManualOrder();

  const rejectOrder = async () => {
    try {
      await rejectManualOrder({ order_id: manualOrder.coop_order_id });
      dispatch({ type: Types.MANUAL_ORDERS_CLEAR });
      history.push('/pharmacy/dashboard');
    } catch {
      history.push('/pharmacy/error');
    }
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.overlayContainer}>
        <div className={styles.headerContainer}>
          <h1>{RejectOrderOverlayContent.headingText}</h1>
          <img src={closeIcon} className={styles.clickableIcon} alt={`Alert`} onClick={() => closeOverlay()} />
        </div>
        <div className={styles.warningConatiner}>
          <img src={alertTriangleIcon} className={styles.icon} alt={`Alert`} />
          <p>{RejectOrderOverlayContent.warningText}</p>
        </div>
        <div className={styles.manualOrderContainer}>
          <div className={`${styles.manualOrderRow} ${styles.spaceBetween}`}>
            <h2>Medication request</h2>
            <h2>
              {manualOrder.order_items.length} item{manualOrder.order_items.length > 1 ? 's' : ''}
            </h2>
          </div>
          <hr className={styles.horizontalRow} />
          {manualOrder.order_items.map((orderItem) => (
            <p>{orderItem.name}</p>
          ))}
          <hr className={styles.horizontalRow} />
          <div className={styles.priceDisplay}>
            <h2>Total</h2>
            <h3>{manualOrder.total_amount === 0 ? 'Free' : `£${manualOrder.total_amount.toFixed(2)}`}</h3>
          </div>
        </div>
        <div className={styles.buttonContainer}>
          <button className={`coop-btn coop-btn--tertiary ${styles.button}`} onClick={() => closeOverlay()}>
            Cancel
          </button>
          <button className={`coop-btn coop-btn--primary ${styles.button}`} onClick={() => rejectOrder()}>
            Reject Order
          </button>
        </div>
      </div>
    </div>
  );
};

export default RejectOrderOverlay;
